<template>
  <v-row no-gutters>
    <v-col cols="12">
      <main-loader v-if="loading" />
      <data-tree-table
        v-else
        :data-tree="dataTree"
        :data-tree-result="dataTreeResult"
        :headers="headers"
        :disable-zoom="disableZoom"
      />
    </v-col>
  </v-row>
</template>
<script>
import DataTreeTable from '@/components/DataTreeTable';
import MainLoader from '@/components/MainLoader';

export default {
  name: 'DataTree',
  components: { DataTreeTable, MainLoader },
  props: {
    dataTree: {
      type: Object,
      required: true,
    },
    dataTreeResult: {
      type: Array,
      default: () => {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    headers: {
      type: Array,
      default: () => {
        return [
          { key: 'name', translationPath: 'sidebar.dataTree.name' },
          { key: 'area', translationPath: 'sidebar.dataTree.area' },
        ];
      },
    },
    disableZoom: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
